import React from 'react';
import namespaceFormats from './namespaceFormats';
import NamespaceFormatsProvider from './NamespaceFormatsProvider';

type DefaultNamespaceFormatsProviderProps = {
  children: React.ReactNode;
};

const DefaultNamespaceFormatsProvider = ({
  children,
}: DefaultNamespaceFormatsProviderProps) => {
  return (
    <NamespaceFormatsProvider namespaceFormats={namespaceFormats}>
      {children}
    </NamespaceFormatsProvider>
  );
};

export default DefaultNamespaceFormatsProvider;
